// ---------------------------------------------------------------------------
// Review Modal — Zod validation schemas for action forms
// ---------------------------------------------------------------------------

import { z } from 'zod';

export const holdSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, 'Reason is required')
    .max(500, 'Reason must be 500 characters or fewer'),
});

export type HoldFormValues = z.infer<typeof holdSchema>;

export const declineSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, 'Reason is required')
    .max(500, 'Reason must be 500 characters or fewer'),
});

export type DeclineFormValues = z.infer<typeof declineSchema>;

export const cancelSchema = z.object({
  reason: z.string().trim().max(500, 'Reason must be 500 characters or fewer').optional(),
});

export type CancelFormValues = z.infer<typeof cancelSchema>;

export const commentSchema = z.object({
  comment: z
    .string()
    .trim()
    .min(1, 'Comment is required')
    .max(1000, 'Comment must be 1000 characters or fewer'),
});

export type CommentFormValues = z.infer<typeof commentSchema>;

export const complianceOverrideSchema = z.object({
  override_decision: z.enum(['approved', 'rejected'], {
    required_error: 'Override decision is required',
  }),
  override_reason: z
    .string()
    .trim()
    .min(1, 'Reason is required')
    .max(500, 'Reason must be 500 characters or fewer'),
});

export type ComplianceOverrideFormValues = z.infer<typeof complianceOverrideSchema>;
